/**
 * @generated SignedSource<<76498c6d8277cfe2ff117e1e2c7cd8e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useProductActivationCheckQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type useProductActivationCheckQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly confluence: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type useProductActivationCheckQuery = {
  response: useProductActivationCheckQuery$data;
  variables: useProductActivationCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "alias": "confluence",
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ],
        "storageKey": "activationIdByProduct(product:\"confluence\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useProductActivationCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProductActivationCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0aaca243db096f4783337cc5e8f7b932",
    "id": null,
    "metadata": {},
    "name": "useProductActivationCheckQuery",
    "operationKind": "query",
    "text": "query useProductActivationCheckQuery(\n  $cloudIds: [ID!]!\n) {\n  tenantContexts(cloudIds: $cloudIds) {\n    confluence: activationIdByProduct(product: \"confluence\") {\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d51a51b48fdb9b51062151868f3c23ae";

export default node;
